<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>热更新配置</span>
        </div>
        <el-button
          v-permisaction="['config:hotUpdate:add']"
          style="margin:0px 0px 10px 0px;"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="edit(0)"
        >新增</el-button>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="gu_version"
            label="版本名称"
            align="center"
          />

          <el-table-column
            prop="gu_title"
            label="版本标题"
            align="center"
          />

          <el-table-column
            prop="gu_force"
            label="强制更新"
            :formatter="getForce"
            align="center"
          />

          <el-table-column
            prop="gu_device"
            label="设备"
            align="center"
          />

          <!--          <el-table-column-->
          <!--            prop="gu_isReward"-->
          <!--            label="是否有奖励"-->
          <!--            align="center"-->
          <!--            :formatter="isReward"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="gu_reward"-->
          <!--            label="奖励内容"-->
          <!--            width="150px"-->
          <!--            :formatter="getReward"-->
          <!--          />-->

          <el-table-column
            prop="gh_news"
            label="是否新的"
            align="center"
            :formatter="isNew"
          />

          <el-table-column
            prop="gu_tips"
            label="是否提醒"
            align="center"
            :formatter="isTips"
          />

          <el-table-column
            fixed="right"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:hotUpdate:add']" size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button v-permisaction="['config:hotUpdate:del']" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center">
          <!--          <el-button v-permisaction="['config:hotUpdate:add']" type="primary" @click="add()">+</el-button>-->
          <!--          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="onSubmit()">保存</el-button>-->
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { delGameUpdate, getGameUpdateList } from '@/api/config/game-update-cfg'
import submenu from 'element-ui/packages/submenu'
export default {
  name: 'GameUpdate',
  data() {
    return {
      drawer: false,
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      propsId: 19,
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      deviceType: [
        { label: '安卓', value: 'android' },
        { label: '苹果', value: 'ios' }
      ],
      options: [],
      formData: {},
      form: {
        'id': 0,
        'gu_version': '',
        'gu_title': '',
        'gu_content': '',
        'gu_force': 0,
        'gu_updateurl': '',
        'gu_commonurl': '',
        'gu_hotfix': 0,
        'gu_device': 'android',
        'gu_langtitle': '',
        'gu_langcontent': '',
        'gu_isReward': 0,
        'gu_reward': { 'spins': 80, 'money': 1000000 },
        'gh_news': 0,
        'gu_tips': 0,
        'remark': ''
      },
      tableData: [
        {
          'id': 0,
          'gu_version': '',
          'gu_title': '',
          'gu_content': '',
          'gu_force': 0,
          'gu_updateurl': '',
          'gu_commonurl': '',
          'gu_hotfix': '',
          'gu_device': 'android',
          'gu_langtitle': '',
          'gu_langcontent': '',
          'gu_isReward': 0,
          'gu_reward': { 'spins': 0, 'money': 0 },
          'gh_news': 0,
          'gu_tips': 0
        }
      ], rules: {
        gu_version: [
          { required: true, message: '请输入版本名称', trigger: 'blur' }
        ], gu_title: [
          { required: true, message: '请输入版本标题', trigger: 'blur' }
        ], gu_updateurl: [
          { required: true, message: '请输入更新url', trigger: 'blur' }
        ], gu_commonurl: [
          { required: true, message: '请输入评论url', trigger: 'blur' }
        ], gu_hotfix: [
          { required: true, message: '请输入热更新地址', trigger: 'blur' }
        ], gu_langtitle: [
          { required: true, message: '请输入多语言标题', trigger: 'blur' }
        ], gu_langcontent: [
          { required: true, message: '请输入多语言内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    submenu() {
      return submenu
    }
  },
  created() {
    this.getTables()
    // this.getChestSkin()
  },
  methods: {
    edit(id) {
      this.$router.push({ name: 'GameUpdateEdit', query: { id: id }})
      // this.drawer = true
      // this.formData = row
    },
    getTables() {
      this.formData = []
      getGameUpdateList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delGameUpdate({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getChestSkin() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          this.options = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }, getReward(row, col, prize) {
      const str = []
      for (const i in prize) {
        const r = prize[i]
        for (const k in this.rewardType) {
          const rt = this.rewardType[k]
          if (r.propsId === rt.value) {
            str.push(rt.label + '*' + r.num)
          }
        }
      }
      return str.join(',')
    }, getForce(row, col) {
      if (row.gu_force === 1) {
        return '是'
      }
      return '否'
    },
    isReward(row, col) {
      if (row.gu_isReward === 1) {
        return '是'
      }
      return '否'
    },
    isNew(row, col) {
      if (row.gh_news === 1) {
        return '是'
      }
      return '否'
    },
    isTips(row, col) {
      if (row.gu_tips === 1) {
        return '是'
      }
      return '否'
    }
  }
}
</script>

<style scoped>
</style>
